import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useWorkStatus, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const WorkStatusPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="workStatus"
      hook={useWorkStatus}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addWorkStatus"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="workStatus"
    />
  );
};

export default WorkStatusPage; 